import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './BlogAdmin.css';

const BlogListAdmin = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const data = await api.get('/blogs');
        setPosts(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await api.delete(`/blogs/${id}`);
        setPosts(posts.filter(post => post.id !== id));
      } catch (err) {
        setError(err.message);
      }
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="blog-admin-container">
      <div className="blog-admin-header">
        <h2>Blog Posts Management</h2>
        <Link to="/blogform" className="btn btn-primary">
          Add New Post
        </Link>
      </div>

      <table className="blog-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Category</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {posts.map(post => (
            <tr key={post.id}>
              <td>{post.title}</td>
              <td>{post.category}</td>
              <td>
                <span className={`status-badge ${post.is_published ? 'published' : 'draft'}`}>
                  {post.is_published ? 'Published' : 'Draft'}
                </span>
              </td>
              <td>{new Date(post.created_at).toLocaleDateString()}</td>
              <td className="actions">
                <Link to={`/admin/blog/edit/${post.id}`} className="btn btn-edit">
                  Edit
                </Link>
                <button 
                  onClick={() => handleDelete(post.id)} 
                  className="btn btn-delete"
                >
                  Delete
                </button>
                <Link to={`/blog/${post.id}`} className="btn btn-view">
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlogListAdmin;